import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // ADICIONE ESTA LINHA

import PrivateMenu from "../sections/Header/privateMenuUp";
import PrivateMenuUp from "../sections/Header/privateMenuUp";
import PrivateMenuLeft from "../sections/Header/privateMenuLeft";
import useAuth from "../../../components/hooks/useAuth";
import AddCampaignModalComponent from "../Campaign/Modals/add";
import { useEffect } from "react";
import Loader from "../../../components/Loader";

const DashboardCampaignListComponent = () => {
  // Sidebar começa fechada em qualquer resolução
  const [showModalAddCampaign, setShowModalAddCampaign] = useState(false);
  const [campaigns, setCampaigns] = useState([]);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [selectedCampaigns, setSelectedCampaigns] = useState([]);
  const [nomeConta, setNomeConta] = useState("");
  const [isLoadingInternal, setIsLoadingInternal] = useState(false);

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate(); // NOVO: hook para navegação

  // Função para abrir o modal com o título correto
  const handleOpenModal = (title) => {
    setShowModalAddCampaign(true);
  };

  // Funções de drag and drop
  const handleDragStart = (index) => setDraggedIndex(index);
  const handleDragOver = (e) => e.preventDefault();
  const handleDrop = (index) => {
    if (draggedIndex === null || draggedIndex === index) return;
    const newCampaigns = [...campaigns];
    const [removed] = newCampaigns.splice(draggedIndex, 1);
    newCampaigns.splice(index, 0, removed);
    setCampaigns(newCampaigns);
    setDraggedIndex(null);
  };

  // Alterna seleção de uma campanha
  const handleSelectCampaign = (id) => {
    setSelectedCampaigns((prev) =>
      prev.includes(id) ? prev.filter((cid) => cid !== id) : [...prev, id]
    );
  };

  // Seleciona ou desmarca todas
  const handleSelectAll = () => {
    if (selectedCampaigns.length === campaigns.length) {
      setSelectedCampaigns([]);
    } else {
      setSelectedCampaigns(campaigns.map((c) => c.id));
    }
  };

  // Função para disparar mensagens para as campanhas selecionadas
  const handleDispararSelecionadas = () => {
    if (selectedCampaigns.length === 0) {
      alert("Selecione ao menos uma campanha!");
      return;
    }
    // Aqui você pode chamar sua API ou lógica de disparo
    alert(
      `Disparando mensagens para as campanhas: ${selectedCampaigns.join(", ")}`
    );
  };

  const { sidebarOpen, getApi, postApi } = useAuth();

  useEffect(() => {

    const intervalId = setInterval(() => {
      console.log(isLoadingInternal)
      if (isLoadingInternal == false) {
        loadCampaigns(false);
      }
    }, 5000);

    return () => clearInterval(intervalId);
  }, [isLoadingInternal]);

  useEffect(() => {
    loadCampaigns();

  }, []);

  const loadCampaigns = async (clean = true) => {
    setIsLoadingInternal(true);
    if (clean) {
      setLoading(true)
    }
    let response = await getApi("/api/v1/campaign/list", {
      limit: 100,
    });

    setCampaigns(response.lista);

    if (clean) {
      setLoading(false)
    }
    if (response) {
      setIsLoadingInternal(false);
    }

  };

  return (
    <React.Fragment>
      <div className="card-body" >
        <h5 className="card-title d-flex align-items-center justify-content-between">
          Campanhas
          <button
            type="button"
            className="btn btn-link p-0 ms-2"
            title="Adicionar"
            style={{ color: "#51a197", fontSize: 22 }} // cor alterada aqui
            onClick={() => handleOpenModal()}
          >
            <i className="bi bi-plus-circle"></i>
          </button>
        </h5>
        {/* Botão para selecionar/desmarcar todas */}
        {/* <div className="mb-2 d-flex align-items-center">
          <input
            type="checkbox"
            checked={
              selectedCampaigns.length === campaigns.length &&
              campaigns.length > 0
            }
            onChange={handleSelectAll}
            id="selectAllCampaigns"
            style={{ marginRight: 8 }}
          />
          <label
            htmlFor="selectAllCampaigns"
            style={{ color: "#fff", fontWeight: 500, cursor: "pointer" }}
          >
            Selecionar todas
          </label>
          <button
            className="btn btn-success btn-sm ms-auto"
            onClick={handleDispararSelecionadas}
            disabled={selectedCampaigns.length === 0}
            style={{ fontWeight: 600 }}
          >
            Enviar selecionadas
          </button>
        </div> */}
        <div
          className="campaign-scroll-area custom-scrollbar"
          style={{
            maxHeight: "350px", // Defina a altura máxima desejada aqui
            overflowY: "auto",
            overflowX: "hidden",
            paddingRight: "5px" // Espaço para não cobrir o conteúdo com a scrollbar
          }}
        >
          {loading && <Loader />}
          {/* Lista de campanhas com seleção */}
          {campaigns.map((camp, idx) => (
            <div
              key={camp.id}
              className="card mb-3 campanha-item"
              style={{
                border: "1px solid #e6e6e6",
                borderRadius: 8,
                boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                background: "#f8f9fa",
                opacity: draggedIndex === idx ? 0.6 : 1,
                display: "flex",
                alignItems: "center",
                padding: "0.5rem",
                cursor: "pointer",
              }}
              onClick={() => navigate(`/campanha/${camp.id}`)}
            >
              <div
                className="d-flex align-items-center"
                style={{ gap: 12, width: "100%" }}
              >
                <input
                  type="checkbox"
                  checked={selectedCampaigns.includes(camp.id)}
                  onChange={() => handleSelectCampaign(camp.id)}
                  onClick={(e) => e.stopPropagation()}
                  style={{ marginRight: 0 }}
                />
                <span
                  className="drag-icon"
                  draggable
                  onDragStart={() => handleDragStart(idx)}
                  onDragOver={handleDragOver}
                  onDrop={() => handleDrop(idx)}
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    cursor: "grab",
                    color: "#bdbdbd",
                    fontSize: 20,
                    display: "flex",
                    alignItems: "center",
                  }}
                  title="Arraste para reordenar"
                >
                  <i className="bi bi-grip-vertical"></i>
                </span>
                <span className="capa-campanha-circulo">
                  <img
                    src={camp.picture_url ? camp.picture_url : "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=100&q=80"}
                    alt={camp.name}
                    style={{
                      width: '35px',     // Tamanho desejado
                      height: '35px',    // Altura igual à largura
                      borderRadius: '50%', // Faz o círculo
                      objectFit: 'cover', // Corta a imagem para preencher sem esticar
                      display: 'block'
                    }}
                  />
                </span>
                <div className="nome-campanha" style={{ flex: 1, minWidth: 0 }}>
                  <span
                    style={{
                      fontWeight: "bold",
                      fontSize: 15,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {camp.name}
                  </span>
                  <div style={{ fontSize: 13, color: "#888" }}>
                    Tipo: {camp.type.name}
                  </div>
                </div>

                  <span className="pulse-status" style={{
                      background: camp.alive ? "#28c76f" : "#ff0000", color: camp.alive ? "#28c76f" : "#ff0000",
                      animation: camp.alive ? 'pulseGreen 1.2s infinite' : 'pulseVermelho 1.2s infinite',
                    }}>
                      <span className="pulse-dot" style={{ background: camp.alive ? "#28c76f" : "#ff0000", color: camp.alive ? "#28c76f" : "#ff0000", }}>
                      </span>
                        
                      
                   </span>
                

              
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Modal Bootstrap */}
      {showModalAddCampaign && (
        <AddCampaignModalComponent
          showModalAddCampaign={showModalAddCampaign}
          setShowModalAddCampaign={setShowModalAddCampaign}
        />
      )}
    </React.Fragment>
  );
};

export default DashboardCampaignListComponent;

<style>
  {`

/* --- Ajuste para o layout mobile quando o menu lateral está aberto --- */
@media (max-width: 768px) {
  .d-flex.flex-column.flex-shrink-0.text-white {
    position: fixed !important;
    left: 0 !important;
    top: 0 !important;
    height: 100vh !important;
    width: 56px !important;      /* Sempre mostra os ícones */
    min-width: 56px !important;
    max-width: 56px !important;
    overflow-x: hidden !important;
    z-index: 3000 !important;
    transition: width 0.3s !important;
    background: #277fa1 !important;
  }
  .d-flex.flex-column.flex-shrink-0.text-white.menu-aberto {
    width: 80vw !important;
    max-width: 260px !important;
    min-width: 56px !important;
    box-shadow: 4px 0 16px rgba(0,0,0,0.18) !important;
    z-index: 3000 !important;
  }
  .main-dashboard-content {
    margin-left: 0 !important;
    width: 100vw !important;
  }
}
`}
</style>;
